import { useKey } from "./useKey"

interface ICheckbox {
    checked: boolean
    setChecked?: (checked: boolean) => void
    label?: string
    className?: string
    tooltip?: string
    onEnter?: () => void
    onEscape?: () => void
}

export function Checkbox({ checked, setChecked, label, className, tooltip, onEnter, onEscape }: ICheckbox) {
    useKey('Escape', () => onEscape && onEscape())
    useKey('Enter', () => onEnter && onEnter())
    
    return (
        <label className={className} title={tooltip}>
            <input
                type="checkbox"
                checked={checked}
                onChange={() => setChecked && setChecked(!checked)}
            />
            {label}
        </label>
    )
}
